import { useContext } from 'react'
import BusinessSettingsContext from '../contexts/BusinessSettingsContext'

export const useBusinessSettingsContext = () => {
  const ctx = useContext(BusinessSettingsContext)
  if (!ctx) {
    throw new Error('useBusinessSettingsContext debe usarse dentro de BusinessSettingsProvider')
  }
  return ctx
}

export default useBusinessSettingsContext
